import React from 'react';
import { ButtonIcon } from '../../base/buttons';

const ButtonCopy = ({
  onClick,
  iconName = 'paste',
  iconSize,
  bsClass,
  bsSize = 'small',
  bsStyle = 'primary',
  btnLabel,
  className
}) => {
  return (
    <ButtonIcon
      className={className}
      iconName={iconName}
      iconSize={iconSize}
      bsClass={bsClass}
      bsSize={bsSize}
      bsStyle={bsStyle}
      btnLabel={btnLabel}
      onClick={onClick}
    />
  );
};

export default ButtonCopy;
